<!-- NEW DIALOG -->
<p-dialog
	*ngIf="isDialogVisible && !severeError"
	header="{{ formTitle | uppercase }}"
	[(visible)]="isDialogVisible"
	[transitionOptions]="'150ms cubic-bezier(0, 0, 0.2, 1)'"
	[modal]="true"
	[draggable]="false"
	[resizable]="false"
	[closeOnEscape]="false"
	(visibleChange)="onVisibleChange()"
  [style]="{ width: '35vw', minWidth: '350px', maxWidth: '35vw', height: 'auto', minHeight: '350px', maxHeight: '40vh' }"
>
 <!-- DIALOG BODY -->
 <div class='d-flex flex-column align-content-center gap-3 p-3'>
    <!-- class="tabPanel" -->
    <!-- <p-tabPanel i18n-header header={{zoneGroupLabel}} > -->
          <div class="container">
            <!-- ROW 1 -->
            <div class="row mb-2">
                <!-- [errors]="errors.zoneGroup" -->
                <form-input [required]="true" i18n-fieldName fieldName={{zoneGroupLabel}} >
    
                    <p-dropdown *ngIf="availableZoneGroups?.length" id="dropdownZoneGroups2" (onChange)="zoneGroupChanged()" placeholder={{zonePlaceholder}}
                    [options]="availableZoneGroups" [(ngModel)]="selectedPreconfig2" [style]="{'width':'100%'}"
                    filter="filter" dataKey="value" optionLabel ="label" appendTo="body"></p-dropdown> 
    
    
                  <button class="AddButton" type="button" pButton icon="fa fa-plus" (click)="createZoneGroup()"
                    i18n-pTooltip pTooltip="Add New Zone Group" tooltipPosition="top"></button>
    
                </form-input>
              </div>
            <!-- ROW 2 -->
            <div class="row mb-2">
            <form-input fieldName="{{eventsLabel}}">
              <ng-container *ngTemplateOutlet="checkboxTemplate"></ng-container>
            </form-input>
            
            <ng-template #checkboxTemplate>
              <div class="d-flex align-items-center">
                <p-checkbox
                  i18n-label
                  [label]="enterLabel"
                  binary="true"
                  [(ngModel)]="eventOnEnter"
                  class="checkbox-spacing"
                ></p-checkbox>
            
                <p-checkbox
                  i18n-label
                  [label]="leaveLabel"
                  binary="true"
                  [(ngModel)]="eventOnLeave"
                ></p-checkbox>
              </div>
            </ng-template>
            </div>
            <!-- <div class="row mb-2">
    
                    <form-input fieldName={{eventsLabel}}></form-input>
    
                  <form-input fieldName=""  >
                    <p-checkbox i18n-label label={{enterLabel}} binary="true"
                      [(ngModel)]="eventOnEnter"></p-checkbox>
                  </form-input>
    
                  <form-input fieldName="" >
                    <p-checkbox i18n-label label={{leaveLabel}} binary="true"
                      [(ngModel)]="eventOnLeave"></p-checkbox>
                  </form-input>
    
          </div> -->
            <!-- ROW 3 RADIO -->
            <div class="row mb-2">

                    <form-input i18n-fieldName fieldName={{radius}} >
                        <input type="number" min="0"  step ="0.01"
                        max="10000" [(ngModel)]="radiusValue" [style]="{'width':'100px'}" (input)="validateQuantity()" />
                      </form-input>
            </div>


        </div>
      <!-- </p-tabPanel> -->
 </div>

 <!-- DIALOG FOOTER-->
 <p-footer>
    <div class='d-flex justify-content-end align-content-center p-2 w-100'>
       <button type='button' class='btn custom-button' (click)='savePoiZone()' [disabled]="generateSpinner" >
          {{ 'general.save' | translate }}
       </button>
       <span *ngIf='generateSpinner' [style]="{ 'margin-left': '20px' }">{{ 'general.wait' | translate }}</span>
    </div>
 </p-footer>


</p-dialog>
<app-zone-group-form #ZoneGroupFormComponent [namegroupzone]="nameGroupZone" [realTime]=true (closeForm)="closeForm($event)"></app-zone-group-form>
<p-confirmDialog i18n-header header="Confirmation" icon="fa fa-question-circle" width="425"></p-confirmDialog>